<ion-item-divider [ngClass]="hostClassString">
  <ion-label [ngClass]="labelClassString">{{ label }}</ion-label>
</ion-item-divider>
